import Http from 'axios'
import {API_URL, VERSION} from '../../../config/config'
import {VISA_PLANS} from "../../../constant/appConstant";
import moment from "moment";

function initialState() {
    return {
        fromPrm:false,
        visaNumber: 123,
        extra_data: [],
        visaNotFound: false,
        visa: {
            traveller: {
                full_name: null
            },
            passport: {},
            extra: {
                address: {},
                application_data: {},
                extra_passport_country: '',
                extra_passport_no: '',
                transport_no: ''
            },
            visaData: {},
            price: null,
            condition: null,
            visaPlan: 3,
            duration: null,
            documents: [],
            visa_type: null,
            visa_type_condition: null
        },
        extendConvertData: {
            changeTo: null,
            passport_number: null,
            condition: null,
            documents: [],
            price: null,
            visaPlan: 3,
            type: null,
            duration: null,
            reason: '',
            start_date: null,
            dependent: null,
            required_documents: {},
        },
        extraPassport: {
            country: null,
            number: null,
        },
        visaCatOptions: VISA_PLANS,
        purposeAutoCompletes: [],
        occupationOptions: [
            "Doctor",
            "Engineer",
            "Government Service",
            "Driver",
            "Foreign Employment",
            "Advocate",
            "Journalist",
            "IT Professional",
            "Student",
            "Other"
        ],
        extendTime: null,
        price: null,
        days: null,
        loading: false,
        pdfDetails: [],
        documents: [],
        extendConvertResponse: {},
        extendConvertVisaDetail: {},
        dependentVisaDetail: null,
        arrivalDepartureCertification: {
            image: null,
            date: null,
            purpose_of_visit: null,
            office: null,
            cost: null,
            country: null,
        },
        visaTransferData: {
            document_type: 'Document',
            document_number: '',
            document_validity: null,
            reason_for_transfer: null,
            document_file: null,
            attached_document: null
        },
        printResponse: {},
        convert_visa_options: [],
        can_extend:0,
        can_convert:0,
        can_overstay_regulation:0,
        can_certification:0,
        can_visa_transfer:0,
        can_plan_upgrade:0,
        can_convert_to:[],
        apply_type: 'online',
        office: '',
        extendConvertTab: '',
        existingVisa: false,
    }
}

const getters = {
    loading: state => state.loading,
    visaFetched: state => state.visaFetched,
    visa: state => state.visa,
    visaNumber: state => state.visaNumber,
    pdfDetails: state => state.pdfDetails,
    purposeAutoCompletes: state => state.purposeAutoCompletes,
    occupationOptions: state => state.occupationOptions,
    visaCatOptions: state => state.visaCatOptions,
    price: state => state.price,
    extra_data: state => state.extra_data,
    extendConvertData: state => state.extendConvertData,
    extraPassport: state => state.extraPassport,
    days: state => state.days,
    extendConvertVisaDetail: state => state.extendConvertVisaDetail,
    convert_visa_options: state => state.convert_visa_options,
    arrivalDepartureCertification: state => state.arrivalDepartureCertification,
    dependentVisaDetail: state => state.dependentVisaDetail,
    printResponse: state => state.printResponse,
    visaTransferData: state => state.visaTransferData,
    apply_type: state => state.apply_type,
    office: state => state.office,
    extendConvertTab: state => state.extendConvertTab,
    existingVisa: state => state.existingVisa
};

const actions = {
    resetState({commit}) {
        commit('resetState')
    },
    saveVisa({commit, state}, apply_type) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            let data = new FormData();
            buildFormData(data, state.visa);
            let office = state.office;
            if (office === 'tia-online') {
                office = 'tia'
            }
            data.append('office', office);
            data.append('apply_type', apply_type);
            if (window.localStorage.getItem('pos'))
                data.append('pos', 1);

            Http.post(API_URL + VERSION + '/save-visa-application', data)
                .then(response => {
                    commit('setLoading', false);
                    // fetchConditionsForExtend
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },

    submitArrivalCertification({state, commit}) {
        commit('setLoading', true);
        let formData = new FormData();
        buildFormData(formData, state.arrivalDepartureCertification);
        formData.append('token', state.extendConvertVisaDetail.access_token);
        formData.append('visa_number', state.extendConvertVisaDetail.visa_number);
        formData.append('apply_office', state.office);
        return new Promise(((resolve, reject) => {
            Http.post(API_URL + VERSION + '/request-arrival-departure-certification', formData).then((res) => {
                commit('setLoading', false);
                resolve(res)
            }).catch((err) => {
                commit('setLoading', false);
                reject(err)
            })
        }));
    },
    submitExtendVisa({state, commit}, data) {

        const {access_token, visa_number, passport_number, custom_created} = state.extendConvertVisaDetail
        const {extend_time, reason} = data;
        const {
            documents,
            condition,
            border_condition,
            plan,
            start_date,
            overstay_processing,
            mobile_number,
            email,
            appointment_date,
            extend_dependent_visa_number,
            extend_dependent_passport_number,
            isIndianHost,
            required_documents,
        } = state.extendConvertData
        const send_data = {
            ...state.visa.extra.application_data,
            token: access_token,
            visa_number,
            passport_number,
            extend_time,
            reason,
            custom_created,
            documents,
            visa_type_condition: condition,
            border_case_condition: border_condition,
            office: state.office,
            plan,
            start_date,
            mobile_number,
            email,
            appointment_date,
            overstay_processing,
            dependent_visa_number: extend_dependent_visa_number,
            dependent_passport_number: extend_dependent_passport_number,
            isIndianHost,
            custom_data: {
                ...state.visa.traveller,
                ...state.visa.passport,
                ...state.visa.visaData
            }
        }
        if (window.localStorage.getItem('pos'))
            send_data.pos = 1;

        let extendData = new FormData();
        Object.keys(send_data).forEach(k => (send_data[k] == null || send_data[k] === '') && delete send_data[k]);
        buildFormData(extendData, send_data);
        buildFormData(extendData, required_documents, 'required_documents');

        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/request-extend-visa`, extendData).then((response) => {
                commit('setLoading', false);
                resolve(response)
            }).catch((error) => {
                commit('setLoading', false);
                reject(error)
            })
        });
    },
    async submitConvertVisa({state, commit}) {

        const {access_token, visa_number, passport_number, custom_created} = state.extendConvertVisaDetail;
        const {
            visaPlan,
            days_staying,
            purpose_of_visa,
            condition,
            border_condition,
            start_date,
            mobile_number,
            email,
            appointment_date,
            apply_with_gratis,
            required_documents,
        } = state.extendConvertData


        const send_data = {
            ...state.visa.extra.application_data,
            token: access_token,
            visa_number,
            days_staying,
            visa_plan: visaPlan,
            purpose_of_visa,
            exchange_type: condition,
            border_case_condition: border_condition,
            passport_number,
            custom_created,
            start_date,
            office: state.office,
            mobile_number,
            email,
            appointment_date,
            apply_with_gratis,
            dependent_visa_number: state.dependentVisaDetail ? state.dependentVisaDetail.visa_number : null,
            dependent_passport_number: state.dependentVisaDetail ? state.dependentVisaDetail.passport_number : null,
            custom_data: {
                ...state.visa.traveller,
                ...state.visa.passport,
                ...state.visa.visaData
            }
        }

        if (window.localStorage.getItem('pos'))
            send_data.pos = 1;

        if (state.dependentVisaDetail) {
            send_data.dependent_visa_number = state.dependentVisaDetail.visa_number;
            send_data.dependent_passport_number = state.dependentVisaDetail.passport_number;
        }

        let data = new FormData();

        Object.keys(send_data).forEach(k => (send_data[k] == null || send_data[k] === '') && delete send_data[k]);
        buildFormData(data, send_data);
        buildFormData(data, required_documents, 'required_documents');
        commit('setLoading', true);

        try {
            const response = await Http.post(`${API_URL}${VERSION}/request-convert-visa`, data);
            commit('setLoading', false);
            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },

    async submitOverstayedConvertVisa({state, commit}) {
        const {access_token, visa_number, passport_number, custom_created} = state.extendConvertVisaDetail;
        const {
            visaPlan,
            days_staying,
            purpose_of_visa,
            condition,
            border_condition,
            start_date,
            mobile_number,
            appointment_date,
            apply_with_gratis,
            required_documents,
        } = state.extendConvertData


        const send_data = {
            ...state.visa.extra.application_data,
            token: access_token,
            visa_number,
            days_staying,
            visa_plan: visaPlan,
            purpose_of_visa,
            exchange_type: condition,
            border_case_condition: border_condition,
            passport_number,
            custom_created,
            start_date,
            office: state.office,
            mobile_number,
            appointment_date,
            apply_with_gratis,
            dependent_visa_number: state.dependentVisaDetail ? state.dependentVisaDetail.visa_number : null,
            dependent_passport_number: state.dependentVisaDetail ? state.dependentVisaDetail.passport_number : null,
            custom_data: {
                ...state.visa.traveller,
                ...state.visa.passport,
                ...state.visa.visaData
            }
        }

        if (window.localStorage.getItem('pos'))
            send_data.pos = 1;

        if (state.dependentVisaDetail) {
            send_data.dependent_visa_number = state.dependentVisaDetail.visa_number;
            send_data.dependent_passport_number = state.dependentVisaDetail.passport_number;
        }

        if(state.extendConvertData.is_special_overstay_regulation){
            send_data.is_special_overstay_regulation = state.extendConvertData.is_special_overstay_regulation
            send_data.special_overstay_regulation_condition = state.extendConvertData.special_overstay_regulation_condition
        }

        let data = new FormData();

        Object.keys(send_data).forEach(k => (send_data[k] == null || send_data[k] === '') && delete send_data[k]);
        buildFormData(data, send_data);
        buildFormData(data, required_documents, 'required_documents');
        commit('setLoading', true);

        try {
            const response = await Http.post(`${API_URL}${VERSION}/request-overstayed-convert-visa`, data);
            commit('setLoading', false);
            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },

    async submitTransferVisa({commit, state}) {
        commit('setLoading', true);
        let formData = new FormData();
        buildFormData(formData, state.visaTransferData);
        formData.append('token', state.extendConvertVisaDetail.access_token);
        formData.append('visa_number', state.extendConvertVisaDetail.visa_number);
        formData.append('office', state.office,);
        if (window.localStorage.getItem('pos'))
            formData.append('pos', 1);

        try {
            const response = await Http.post(API_URL + VERSION + '/request-for-transfer', formData);
            commit('setLoading', false);
            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    async submitPlanUpgrade({commit, state}, data) {
        commit('setLoading', true);
        const formData = new FormData();
        formData.append('visa_plan', data);
        formData.append('token', state.extendConvertVisaDetail.access_token);
        formData.append('visa_number', state.extendConvertVisaDetail.visa_number);
        formData.append('office', state.office);
        if (window.localStorage.getItem('pos'))
            formData.append('pos', 1);

        try {
            const response = await Http.post(API_URL + VERSION + '/request-for-update', formData);
            commit('setLoading', false);
            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    async searchForVisa({commit, state}, input_data) {
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + '/search-visa', {
                params: input_data
            });
            state.extendConvertVisaDetail = data.visa_detail;
            state.convert_visa_options = data.convert_visa_types;
            state.can_convert = data.can_convert;
            state.can_extend = data.can_extend;
            state.can_overstay_regulation = data.can_overstay_regulation;
            state.can_certification = data.can_certification;
            state.can_visa_transfer = data.can_visa_transfer;
            state.can_plan_upgrade = data.can_plan_upgrade;
            state.can_convert_to = data.can_convert_to;
            commit('setArrivalStartDate');
            commit('setLoading', false);
            this.dispatch('VisaType/fetchConditionsForExtend')

            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },

    async searchForVisaIfAny({commit}, input_data) {
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + '/search-visa-if-any', {
                params: input_data
            });
            commit('setVisaIfAny', data.data);
            commit('setLoading', false);
            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },
    async checkVisaInfo({commit}, input_data) {
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + '/public/check-visa', {
                params: input_data
            });
            commit('setLoading', false);
            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },
    async checkTrekkingPermitInfo({commit}, input_data) {
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + '/public/check-trekking-permit', {
                params: input_data
            });
            commit('setLoading', false);
            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },
    async checkDocumentInformationValidation({state, commit}) {
        commit('setLoading', true);
        try {
            const response = await Http.post(`${API_URL}${VERSION}/document-information-validation`, state.visa);
            commit('setLoading', false);
            if (response.data.existing_visa)
                commit('setExistingVisa');

            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    async checkExistingUnapprovedVisa({ commit},input_data) {
        console.log(input_data,input_data)
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + `/check-existing-unapproved-visa`, {
                params: input_data
            });
            commit('setLoading', false);
            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },
    async checkExistingEtaUnapprovedVisa({ commit},input_data) {
        console.log(input_data,input_data)
        commit('setLoading', true);
        try {
            let {data} = await Http.get(API_URL + VERSION + `/check-existing-eta-visa`, {
                params: input_data
            });
            commit('setLoading', false);
            return data;
        } catch (e) {
            commit('setLoading', false);
            throw  e;
        }
    },
        checkVisaStatus({state}) {
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/check-traveller-status', {
                params: {
                    dob: state.visa.traveller.dob,
                    full_name: state.visa.traveller.full_name,
                    passport_number: state.visa.passport.passport_number,
                    passport_type: state.visa.passport.passport_type,
                    country: state.visa.traveller.country,
                    days: state.days,
                    visa_type_condition: state.visa.condition
                }
            }).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err)
            });
        })
    },
    getDependentVisaDetail({commit, state}) {
        commit('setLoading', true);
        return new Promise(((resolve, reject) => {
            Http.get(API_URL + VERSION + '/visa-dependent-detail', {
                params: {
                    visa_number: state.visa.extra.application_data.dependent_visa_number,
                    passport_number: state.visa.extra.application_data.dependent_passport_number,
                }
            }).then((response) => {
                commit('setDependentVisaDetails', response.data);
                commit('setLoading', false);

                response(response)
            }).catch((error) => {
                reject(error);
                commit('setLoading', false);
            })
        }));
    },
    processWithVisaNotFound({state}) {
        const {visa} = state;
        const {full_name, dob, country_id, contact_number, occupation} = visa.traveller;
        const {passport_type, passport_number, validity} = visa.passport;
        const {visa_type, start_date, expiry_date, visa_number, visa_plan} = visa.visaData
        const visa_types = this.getters['VisaType/visa_types'];
        const selected_visa_type = visa_types.find(i => i.id === visa_type)
        const countries = this.getters['CountryForTouristList/all']
        const selected_country = countries.find(i => i.id === country_id)
        let plan = VISA_PLANS.find(i => i.key === visa_plan)
        plan = plan.value
        const convert_visa_types = visa_types.filter(i => i.id !== visa_type)
        let expiry_date_moment = moment(expiry_date)
        let late_days = moment().diff(expiry_date_moment, 'days')
        if (late_days > 0) {
            late_days = late_days - 1
        }
        const slug = selected_visa_type.slug
        state.extendConvertVisaDetail = {
            full_name,
            document_type: passport_type,
            passport_number,
            start_date,
            expiry_date,
            visa_number,
            country_name: selected_country.country_name,
            country_id,
            country_code: selected_country.code,
            dob,
            slug,
            contact_number,
            occupation,
            validity,
            count_in_visa_year: 1,
            remaining_days: true,
            extendable: (slug !== 'official-visa' || slug !== 'diplomatic-visa'),
            custom_created: 1,
            extend_cost: selected_visa_type.extend_fee,
            late_days,
            days_stayed: 0,
            late_fee_per_day: selected_visa_type.late_fee_per_day,
            overstay_cost_per_day: 1,
            arrival_departure_certification_cost: selected_visa_type.arrival_departure_certification_cost,
            visa_transfer_cost: selected_visa_type.visa_transfer_cost,
            visa_type: selected_visa_type.type,
            visa_plan,
            plan,
            sre_cost: selected_visa_type.sre_cost,
            mre_cost: selected_visa_type.mre_cost,
            dependent_visa: slug === 'dependent-visa'
        }
        state.convert_visa_options = convert_visa_types
        this.dispatch('VisaType/fetchConditionsForExtend')

    }
};

const mutations = {
    setVisa(state, items) {
        state.visa = items
    },
    setExtraData(state, items) {
        state.extra_data = items;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    // eslint-disable-next-line no-unused-vars
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setPdfDetails(state, pdfDetails) {
        state.pdfDetails = pdfDetails;
    },
    setPrintResponse(state, items) {
        state.printResponse = items;
    },
    setExtendPassportNumber(state, passport_number) {
        state.extendPassportNumber = passport_number;
    },
    setPrice(state, item) {
        state.price = item.cost;
        state.days = item.days;
        state.visa.price = item.cost;
    },
    setArrivalStartDate(state) {
        let today_date = new Date();
        today_date.setDate(today_date.getDate() - 2);
        state.arrivalDepartureCertification.date = today_date.toISOString().substr(0, 10);
    },
    setVisaType(state, item) {
        state.visa.visa_type = item;
    },
    setDependentVisaDetails(state, item) {
        state.dependentVisaDetail = item;
    },
    setVisaTypeCondition(state, item) {
        state.visa.visa_type_condition = item;
    },
    setArrivalCertificationPrintContent(state, item) {
        state.arrivalCertificationData = item;
    },
    setApplyType(state, apply_type) {
        state.apply_type = apply_type;
    },
    setDocuments(state) {
        let conditions = this.getters['VisaTypeSingle/conditions'];
        let condition = conditions.find(i => i.id === state.extendConvertData.condition);

        state.extendConvertData.documents = condition.document_types.filter((i) => i.show_front === 1).map((i) => {
            return {
                id: i.id,
                name: i.name,
                remarks: i.remarks,
                required: i.required,
                label: i.name + ((i.required === 1) ? " number * " : " number "),
                file: null,
                number: null
            }
        });
        this.commit('VisaSingle/calculateExtendPrice');
    },
    setOffice(state, office) {
        state.office = office;
    },
    setExtendConvertTab(state, tab) {
        state.extendConvertTab = tab;
    },
    setLastArrivalCountry(state, country) {
        state.visa.last_arriving_country = country;
    },
    setExistingVisa(state) {
        state.existingVisa = true;
    },
    setVisaIfAny(state, data) {
        const visa = JSON.parse(JSON.stringify(state.visa));

        if (visa.passport.passport_number)
            data.passport.passport_number = visa.passport.passport_number

        if (visa.passport.validity)
            data.passport.validity = visa.passport.validity
        visa.passport = data.passport;

        if (visa.traveller.gender)
            data.traveller.gender = visa.traveller.gender
        if (visa.traveller.full_name)
            data.traveller.full_name = visa.traveller.full_name

        visa.traveller = data.traveller;
        state.visa = visa;
    },
    setPassportNumber(state, no) {
        state.visa.passport.passport_number = no;
    },
    setPassportValidity(state, validity) {
        state.visa.passport.validity = validity;
    },
    setDOB(state, dob) {
        state.visa.traveller.dob = dob;
    },
    setCountry(state, country) {
        state.visa.traveller.country_id = country.id;
    },
    setGender(state, gender) {
        state.visa.traveller.gender = gender;
    },
    setFullName(state, full_name) {
        state.visa.traveller.full_name = full_name;
    },
    setExtendConvertDataCondition(state, condition) {
        state.extendConvertData.condition = condition;
    },
    setExtendConvertDataConditionForBorderCase(state, condition) {
        state.extendConvertData.border_condition = condition;
    },
    setExtendConvertDataRequiredDocuments(state, data) {
        state.extendConvertData.required_documents = data;
    }

};

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
